import { Component, Input } from '@angular/core';
import { BaseElement } from '../../models/base-element';
import { Footer } from '../../models/footer';
import { NgClass, NgStyle, NgComponentOutlet } from '@angular/common';
import { StylePipe } from '../../pipes/style.pipe';
import { ClassPipe } from '../../pipes/class.pipe';

@Component({
    selector: 'portal-footer, [portal-footer]',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [
        NgClass,
        NgStyle,
        NgComponentOutlet,
        StylePipe,
        ClassPipe,
    ],
})
export class FooterComponent {

  footer: Footer | null = null;

  @Input() set element(value: BaseElement) {
    this.footer = value as Footer;
  };

  constructor(

  ) { }

}
